import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async'; // Updated to match your App.tsx provider
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import ValuesSection from './components/ValuesSection';
import TeamSection from './components/TeamSection';
import TimelineSection from './components/TimelineSection';
import CertificationsSection from './components/CertificationsSection';
import CultureSection from './components/CultureSection';
import CTASection from './components/CTASection';

const AboutUs: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Structured Data for Google (Organization Schema)
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "mainEntity": {
      "@type": "Organization",
      "name": "Make Mind Automations",
      "foundingDate": "2025", // Adjust as needed
      "description": "Expert automation agency specializing in n8n, Make.com, and AI Chatbots.",
      "url": "https://www.makemindautomations.tech"
    }
  };

  return (
    <>
      <Helmet>
        <title>About Us | Make Mind Automations</title>
        <meta
          name="description"
          content="We are a team of automation engineers and AI strategists dedicated to saving businesses 40+ hours a week. Meet the experts behind the code."
        />
        <meta
          name="keywords"
          content="Automation Agency Team, n8n Experts, Make.com Consultants, AI Implementation Agency"
        />
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
        <link
  rel="canonical"
  href="https://www.makemindautomations.tech/about-us"
/>
        <meta property="og:type" content="website" />
        <meta property="og:title" content="About Us | Make Mind Automations" />
        <meta property="og:description" content="We are a team of automation engineers and AI strategists dedicated to saving businesses 40+ hours a week. Meet the experts behind the code." />
        <meta property="og:url" content="https://www.makemindautomations.tech/about-us" />
      </Helmet>

      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        <main className="flex-grow">
          <HeroSection />
          <MissionSection />
          <ValuesSection />
          <TimelineSection />
          <CertificationsSection />
          <CultureSection />
          <TeamSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
};



export default AboutUs;